import React, { useEffect, useRef } from 'react';

const CustomCursor = () => {
    const cursorRef = useRef(null);
    const followerRef = useRef(null);

    useEffect(() => {
        const cursor = cursorRef.current;
        const follower = followerRef.current;

        const moveCursor = (e) => {
            const { clientX, clientY } = e;

            // Main cursor
            if (cursor) {
                cursor.style.transform = `translate3d(${clientX - 4}px, ${clientY - 4}px, 0)`;
            }

            // Follower with delay
            if (follower) {
                follower.style.transform = `translate3d(${clientX - 16}px, ${clientY - 16}px, 0)`;
            }
        };

        const handleMouseDown = () => {
            if (cursor) cursor.style.transform += ' scale(0.8)';
            if (follower) follower.style.transform += ' scale(1.5)';
        };

        const handleMouseUp = () => {
            // styles will revert on next mousemove or via css transition
        };

        window.addEventListener('mousemove', moveCursor);
        window.addEventListener('mousedown', handleMouseDown);
        window.addEventListener('mouseup', handleMouseUp);

        return () => {
            window.removeEventListener('mousemove', moveCursor);
            window.removeEventListener('mousedown', handleMouseDown);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);

    return (
        <>
            <div
                ref={cursorRef}
                className="fixed top-0 left-0 w-2 h-2 bg-white rounded-full pointer-events-none z-[9999] mix-blend-difference"
            />
            <div
                ref={followerRef}
                className="fixed top-0 left-0 w-8 h-8 rounded-full border border-white/50 pointer-events-none z-[9998] transition-transform duration-100 ease-out mix-blend-difference"
            />
        </>
    );
};

export default CustomCursor;
